import PageHeader from "../../../components/ui/PageHeader";

/** Legacy adapter (UI-1) over the canonical PageHeader; `eyebrow` is no longer shown. */
// eslint-disable-next-line no-unused-vars
export default function OrdersWorkspaceHeader({ eyebrow, title, subtitle, meta, children }) {
  return <PageHeader title={title} description={subtitle} meta={meta} actions={children} />;
}
